// src/components/resumo/annotations/UnsavedChangesModal.tsx
// 🎯 Modal de confirmação para alterações não salvas

import React from 'react';
import { AlertTriangle, Save, X } from 'lucide-react';
import './UnsavedChangesModal.css';

interface UnsavedChangesModalProps {
    isOpen: boolean;
    onSave: () => Promise<void>;
    onDiscard: () => void;
    onCancel: () => void;
    darkMode?: boolean;
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
    isOpen,
    onSave,
    onDiscard,
    onCancel,
    darkMode = false
}) => {
    const [saving, setSaving] = React.useState(false);

    if (!isOpen) return null;

    const handleSave = async () => {
        setSaving(true);
        await onSave();
        setSaving(false);
    };

    return (
        <div className={`unsaved-modal-overlay ${darkMode ? 'dark' : ''}`} onClick={onCancel}>
            <div className="unsaved-modal" onClick={(e) => e.stopPropagation()}>
                <div className="unsaved-modal-icon">
                    <AlertTriangle size={48} />
                </div>

                <h2 className="unsaved-modal-title">Alterações Não Salvas</h2>
                <p className="unsaved-modal-message">
                    Você tem grifos ou notas que não foram salvos. O que deseja fazer?
                </p>

                <div className="unsaved-modal-actions">
                    <button
                        className="unsaved-btn unsaved-btn-cancel"
                        onClick={onCancel}
                        disabled={saving}
                    >
                        <X size={18} />
                        <span>Cancelar</span>
                    </button>

                    <button
                        className="unsaved-btn unsaved-btn-discard"
                        onClick={onDiscard}
                        disabled={saving}
                    >
                        <span>Descartar</span>
                    </button>

                    <button
                        className="unsaved-btn unsaved-btn-save"
                        onClick={handleSave}
                        disabled={saving}
                    >
                        <Save size={18} />
                        <span>{saving ? 'Salvando...' : 'Salvar'}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UnsavedChangesModal;